import { createElement } from "react";
import styles from "./Tags.module.css";
import { tagsVariantKey } from "./tagsVariant.js";

/**
 * @typedef {'brandPrimary' | 'midnight' | 'white' | 'sage' | 'brandSecondary' | 'softSage'} TagsColor
 * Figma `Color`: Mint → brand primary, Midnight, White, Sage, brand secondary, Soft Sage
 * @typedef {'filled' | 'stroked'} TagsVariant
 * Figma `Type`: Filled | Stroked
 */

const VARIANT_CLASS = {
  brandPrimaryFilled: styles.brandPrimaryFilled,
  brandPrimaryStroked: styles.brandPrimaryStroked,
  midnightFilled: styles.midnightFilled,
  midnightStroked: styles.midnightStroked,
  whiteFilled: styles.whiteFilled,
  whiteStroked: styles.whiteStroked,
  sageFilled: styles.sageFilled,
  softSageStroked: styles.softSageStroked,
  brandSecondaryFilled: styles.brandSecondaryFilled,
  brandSecondaryStroked: styles.brandSecondaryStroked,
};

/**
 * Compact reminder-style tag pill from Figma "Tags" (node 375:4455).
 */
export default function Tags({
  label,
  color = "brandPrimary",
  variant = "filled",
  as = "span",
  className,
  ...rest
}) {
  const key = tagsVariantKey(color, variant);
  const toneClass = VARIANT_CLASS[key] ?? VARIANT_CLASS.brandPrimaryFilled;
  const rootClass = [styles.root, toneClass, className].filter(Boolean).join(" ");

  return createElement(
    as,
    { className: rootClass, ...rest },
    <span className={styles.label}>{label}</span>,
  );
}
